import clsx from "clsx";

export interface ITableParams {
  columnLength: number;
  rowLength?: number;
  bodyLength?: number;
  containerClassName?: string;
}

const TableSkeletonComponent: React.FC<ITableParams> = ({
  columnLength,
  rowLength,
  bodyLength,
  containerClassName,
}) => {
  const totalColumns = bodyLength ? bodyLength : columnLength || 6;
  const totalRows = rowLength ?? (bodyLength ? bodyLength : columnLength - 1 || 5);
  return (
    <div className={clsx("bg-white mt-8 h-[400px] overflow-scroll animate-pulse", containerClassName)}>
      <table className="rounded-md divide-y divide-gray-200 min-w-full">
        <thead className="top-0 sticky bg-[#F7F7F7] shadow-sm rounded-md">
          <tr>
            {/* Skeleton Header */}
            {[...Array(columnLength || 6)].map((_, index) => (
              <th
                key={index}
                className="px-3 py-3 text-left text-xs font-medium text-gray-300 capitalize tracking-wider"
              >
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {/* Skeleton Rows */}
          {[...Array(totalRows)].map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b">
              {[...Array(totalColumns)].map((_, colIndex) => (
                <td key={colIndex} className="px-3 py-4 whitespace-nowrap text-xs font-normal text-gray-300">
                  <div className="h-3 bg-gray-200 rounded w-full"></div>
                </td>
              ))}
              <td className="px-3 py-4 whitespace-nowrap text-xs font-normal text-gray-300">
                <div className="h-6 bg-gray-200 rounded w-1/2"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeletonComponent;
